var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltersList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1229 -114) translate(1214 108) translate(15 6) translate(7 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 1c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1H.995C.445 2 0 1.556 0 1z",
    transform: "translate(-1229 -114) translate(1214 108) translate(15 6) translate(9 13)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 1c0-.552.451-1 .99-1h4.02C5.555 0 6 .444 6 1c0 .552-.451 1-.99 1H.99C.445 2 0 1.556 0 1z",
    transform: "translate(-1229 -114) translate(1214 108) translate(15 6) translate(11 19)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersList);
export default __webpack_public_path__ + "static/media/filters-list.561b040353aa83009336044f67225602.svg";
export { ForwardRef as ReactComponent };